import { setLocaleConfig } from '~~/shared/validation/set-locale-config'

export default defineNuxtPlugin({
  name: 'form-validation',
  setup() {
    setLocaleConfig()
  },
})
